import React from 'react';
import { Button } from './ui/button';

const EligibilitySection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="absolute -left-4 top-0 bottom-0 w-1 bg-gray-200"></div>
            <img
              src="https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/cp9tc9mx_faceless_medium-shot_of_old_indian_man_sitting_in_a_chair_wit_066fdf27-bd68-408f-aba7-3a212475d7b3_2.png"
              alt="Professional investor"
              className="w-full max-w-md mx-auto"
            />
          </div>

          {/* Right Content */}
          <div>
            <h2 className="text-[#1a3a5c] text-3xl md:text-4xl font-bold mb-6 uppercase">
              Who Is The U.S. Visa For?
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Ideal for entrepreneurs, investors, and families from around the world, including students and professionals currently on F-1, H1B, or other U.S. visas, who dream of making the U.S. their permanent home.
            </p>

            <Button
              onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-[#1a3a5c] text-[#1a3a5c] hover:bg-[#1a3a5c] hover:text-white px-8 py-3 rounded font-medium"
            >
              Check Your Eligibility
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilitySection;
